import React from 'react';
import styled, { css } from 'styled-components';
import { string, func, shape, oneOf } from 'prop-types';
import Image from '@bbc/psammead-image';
import PlayButton from '@bbc/psammead-play-button';
import { C_POSTBOX } from '@bbc/psammead-styles/colours';
import Guidance from '../Guidance';
var StyledPlaceholder = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPlaceholder",
  componentId: "sc-11nyhtu-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;", ""], function (_ref) {
  var noJsClassName = _ref.noJsClassName;
  return "cursor: ".concat(noJsClassName ? 'default' : 'pointer', ";");
});
var StyledPlayButton = /*#__PURE__*/styled(PlayButton).withConfig({
  displayName: "StyledPlayButton",
  componentId: "sc-11nyhtu-1"
})(["position:absolute;bottom:0;", " ", ":hover &,", ":focus &{background-color:", ";}"], function (_ref2) {
  var noJsClassName = _ref2.noJsClassName;
  return noJsClassName && css([".", " &{display:none;}"], noJsClassName);
}, StyledPlaceholder, StyledPlaceholder, C_POSTBOX);

var Placeholder = function Placeholder(_ref3) {
  var onClick = _ref3.onClick,
      service = _ref3.service,
      src = _ref3.src,
      srcset = _ref3.srcset,
      mediaInfo = _ref3.mediaInfo,
      noJsClassName = _ref3.noJsClassName,
      noJsMessage = _ref3.noJsMessage;
  var title = mediaInfo.title,
      datetime = mediaInfo.datetime,
      duration = mediaInfo.duration,
      durationSpoken = mediaInfo.durationSpoken,
      type = mediaInfo.type,
      guidanceMessage = mediaInfo.guidanceMessage;
  return /*#__PURE__*/React.createElement(StyledPlaceholder, {
    onClick: onClick,
    noJsClassName: noJsClassName
  }, /*#__PURE__*/React.createElement(Guidance, {
    service: service,
    guidanceMessage: guidanceMessage,
    noJsClassName: noJsClassName,
    noJsMessage: noJsMessage
  }), /*#__PURE__*/React.createElement(StyledPlayButton, {
    title: title,
    service: service,
    onClick: function onClick() {},
    datetime: datetime,
    duration: duration,
    durationSpoken: durationSpoken,
    type: type,
    guidanceMessage: guidanceMessage,
    noJsClassName: noJsClassName
  }), /*#__PURE__*/React.createElement(Image, {
    alt: "",
    src: src,
    srcset: srcset
  }));
};

Placeholder.propTypes = {
  onClick: func.isRequired,
  service: string.isRequired,
  src: string.isRequired,
  srcset: string,
  noJsClassName: string,
  noJsMessage: string.isRequired,
  mediaInfo: shape({
    title: string.isRequired,
    datetime: string,
    duration: string,
    durationSpoken: string,
    type: oneOf(['audio', 'video']),
    guidanceMessage: string
  })
};
Placeholder.defaultProps = {
  srcset: null,
  noJsClassName: null,
  mediaInfo: shape({
    datetime: null,
    duration: null,
    durationSpoken: null,
    type: 'video',
    guidanceMessage: null
  })
};
export default Placeholder;